<script>
  /* Executable code section of the program */
  //Tools importation
  import {
    isCustomTableModalOn,
    isUpdateTableModal,
    currentEvent,
    invitedAttendeesArray,
    objData,
    temporalData,
    indexPositionData,
    isAlertOn,
    alertMessagge,
    isReloadNecessary,
    confirmDeleteCustomTable
  } from "../../apis/storage";
  import {
    idGenerator,
    updateDocument,
    updateMultipleDocuments,
    addAndDeleteMultipleDocuments
  } from "../../apis/APIS";

  //Components importation
  import SelectAttendees from "../SelectAttendees.svelte";

  //Auxiliary variables
  let data = {};
  let attendeeCustomTable = [];
  let eventCustomTable = [];

  if ($isUpdateTableModal) {
    data = $objData;
    $invitedAttendeesArray = $objData.attendeesAuthorized;
    
  }

  //Function to display modal alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  //Function to undisplay modal
  const undisplayModal = () => {
    $isCustomTableModalOn = false;
    $isUpdateTableModal = false;
    $invitedAttendeesArray = [];
  };

  //Function to create custom tables
  const createCustomTables = () => {
    //auxiliary variables
    data.attendeesAuthorized = $invitedAttendeesArray;
    data.event = $currentEvent;
    data.id = idGenerator();

    //Conditional for verify if all fields are complete
    if ($invitedAttendeesArray.length > 0 && data.tableTittle !== "") {
      $invitedAttendeesArray.map((element) => {
        attendeeCustomTable.push({
          id: element.id,
          fieldName: "customTables",
          values: [{ id: data.id, tableName: data.tableTittle }],
        });
      });
      //function to add this custom table to attendees
      updateMultipleDocuments("users", attendeeCustomTable)
        .then(() => {
          $temporalData.customTables.push(data);
          updateDocument("events", $temporalData, $temporalData.id, false).then(
            () => {
              $alertMessagge = "Custom table created successfully";
              $isReloadNecessary = true
              displayAlert();
          $invitedAttendeesArray = [];
          $isCustomTableModalOn = false;
            }
          );
        })
        .catch(() => {
          $alertMessagge = "An error occurred while creating the custom table." 
          displayAlert();
        });
    } else {
      {
        $alertMessagge =
          "You have not assigned this table to any attendee or table tittle is empty.";
        displayAlert();
      }
    }
  };
  //Funciton to update custom tables
  const updateCustomTables = () => {
    //Auxiliary variables
    let currentTable = $temporalData.customTables;
    data.attendeesAuthorized = $invitedAttendeesArray;

    //Conditional for verify if all fields are complete
    if ($invitedAttendeesArray.length > 0 && data.tableTittle !== "") {
      let finalArray = []
        finalArray = data.attendeesAuthorized.concat($invitedAttendeesArray)
        let deleteAttendeesArray = [];
        data.attendeesAuthorized = $invitedAttendeesArray;
        //Attendee break asignation
        finalArray.forEach((element) =>{
          const found =  $invitedAttendeesArray.some((attendee) => element.id === attendee.id)
        
          if (found) {
            attendeeCustomTable.push({
            id: element.id,
            fieldName: "customTables",
            values: [{
              id:data.id,
              tableName:data.tableTittle
            }],
          });
        } else {
          deleteAttendeesArray.push({
            id: element.id,
            fieldName: "customTables",
            values: [{
              id:data.id,
              tableName:data.tableTittle
            }],
          });
        }
        });
      /* $invitedAttendeesArray.map((element) => {
        //This is where the data is added to the array, in order to personalize the custom table and assign it to every user.
        attendeeCustomTable.push({
          id: element.id,
          fieldName: "customTables",
          values: [{ id: data.id, tableName: data.tableTittle }],
        });
      }); */
      //function to add this custom table to attendees
      addAndDeleteMultipleDocuments("users", deleteAttendeesArray, attendeeCustomTable,true)
        .then(() => {
          updateDocument("events", $temporalData, $temporalData.id, false).then(
            () =>{
            $alertMessagge = "Custom table updated successfully"
          $isReloadNecessary = true
            displayAlert()
          $invitedAttendeesArray = [];
          $isCustomTableModalOn = false;
          });
        })
        .catch(() =>{
            $alertMessagge = "An error occurred while updating the custom table." 
            displayAlert()
          });
    } else {
      $alertMessagge = "You have not assigned this table to any attendee."
      displayAlert()
    }
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        class="bi bi-x-lg icon"
        viewBox="0 0 16 16"
        on:click={undisplayModal}
        on:keypress={undisplayModal}
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
        />
      </svg>
    </div>
    <div class="bodyContent">
      <div class="headerBody">
        {#if $isUpdateTableModal}
          <h1>Update Custom Table</h1>
        {:else}
          <h1>Create Custom Table</h1>
        {/if}
      </div>
      <div class="inputsBody">
        <div class="form-floating">
          <input
            type="text"
            class="form-control inputForm"
            placeholder="Tittle Event"
            bind:value={data.tableTittle}
          />
          <label for="floatingPassword">Table Tittle</label>
        </div>
      </div>
      <div class="attendeesList">
        <h2>Attendee authorization</h2>
        <SelectAttendees eventUser={$currentEvent} />
      </div>
    </div>
    <div class="footerContent">
      <button class="actionBtn addEventBtn" on:click={undisplayModal}
        >Close</button
      >
      {#if $isUpdateTableModal}
        <button
          class="actionBtn addEventBtn"
          on:click={() => updateCustomTables()}>Update Table</button
        >
      {:else}
        <button
          class="actionBtn addEventBtn"
          on:click={() => createCustomTables()}>Create Table</button
        >
      {/if}
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.514);
    display: flex;
    justify-content: center;
    padding: 30px;
  }
  /* Content styles */
  .contentContainer {
    overflow: auto;
    width: 80%;
    height: auto;
    max-height: 100vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* HeaderContent styles */
  .headerContent {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 50px 20px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* BodyContent styles */
  .bodyContent {
    width: 90%;
  }
  /* HeaderBody Styles */
  .headerBody {
    width: 100%;
  }
  h1 {
    padding: 10px;
    border-bottom: 1px solid gray;
  }
  /* BodyBody Styles */
  .inputsBody {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    border-bottom: 1px solid gray;
  }
  .form-floating {
    width: 50%;
    margin: 10px;
  }
  /* Attendees styles */
  h2 {
    padding: 15px;
  }
  /* FooterBody styles */
  .footerContent {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    padding: 30px;
  }
  .actionBtn {
    width: 250px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Principal styles */
    .principalContainer {
      padding: 15px;
    }
    /* Content styles */
    .contentContainer {
      width: 90%;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Principal styles */
    .principalContainer {
      padding: 5px;
    }
    /* Content styles */
    .contentContainer {
      width: 100%;
    }
    /* HeaderContent styles */
    .headerContent {
      padding: 20px;
    }
    /* BodyBody Styles */
    .inputsBody {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      border-bottom: 1px solid gray;
    }
    .form-floating {
      width: 100%;
      margin: 5px;
    }
    .actionBtn {
      width: 250px;
      border-radius: 12px;
      margin: 5px;
    }
  }
  /* End of the section */
</style>
